<script setup>
import { ref } from 'vue';
import { Head, Link, useForm } from '@inertiajs/vue3';
import AuthenticationCard from '@/Components/AuthenticationCard.vue';
import ApplicationMark from '@/Components/ApplicationMark.vue';
import Button from 'primevue/button';
import InputError from '@/Components/InputError.vue';
import InputLabel from '@/Components/InputLabel.vue';
import TextInput from '@/Components/TextInput.vue';

defineProps({
    status: String,
});

const showPassword = ref(false)

const form = useForm({
    password: '',
});

const submit = () => {
    form.transform(data => ({
        ...data,
    })).post(route('login-as-guest'), {
        onFinish: () => form.reset('password'),
    });
};

const darkModeLabelClasses = 'dark:text-sky-100'
</script>

<template>
    <Head title="Connexion - Div'app" />

    <AuthenticationCard>
        <template #logo>
            <ApplicationMark />
        </template>

        <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
            {{ status }}
        </div>

        <form @submit.prevent="submit">
            <div class="text-center mb-4">
                <a href="login" class="mt-4 text-sm text-ce text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300">
                    <span class="text-sm font-medium">> Cliquez ici pour une connexion en tant qu'utilisateur <</span>
                </a>
            </div>
            <div class="mt-4">
                <InputLabel :class="darkModeLabelClasses" for="password" value="Code invité" />
                <div class="relative">
                    <TextInput
                        id="password"
                        v-model="form.password"
                        :type="showPassword ? 'text' : 'password'"
                        class="mt-1 block w-full"
                        required
                        autocomplete="current-password"
                    />
                    <button
                        type="button"
                        @click="showPassword = !showPassword"
                        class="absolute inset-y-0 right-0 px-3 flex items-center text-gray-500"
                        :aria-label="showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'"
                    >
                        <span v-if="showPassword">🙈</span>
                        <span v-else>👁️</span>
                    </button>
                </div>
                <InputError class="mt-2" :message="form.errors.password" />
            </div>

            <div class="flex items-center justify-end mt-4">
                <Button class="ms-4 font-semibold" :loading="form.processing" :disabled="form.processing" type="submit" label="Connexion">
                </Button>
            </div>
        </form>
    </AuthenticationCard>
</template>
